const types = {
  LOGIN: 'app/auth/LOGIN',
  LOGIN_SUCCESS: 'app/auth/LOGIN_SUCCESS',
  LOGIN_FAIL: 'app/auth/LOGIN_FAIL',
  REFRESH: 'app/auth/REFRESH',
  REFRESH_SUCCESS: 'app/auth/REFRESH_SUCCESS',
  REFRESH_FAIL: 'app/auth/REFRESH_FAIL',
  VERIFY: 'app/auth/VERIFY',
  VERIFY_SUCCESS: 'app/auth/VERIFY_SUCCESS',
  VERIFY_FAIL: 'app/auth/VERIFY_FAIL',
  VALIDATE_MOBILE: 'app/auth/VALIDATE_MOBILE',
  VALIDATE_MOBILE_SUCCESS: 'app/auth/VALIDATE_MOBILE_SUCCESS',
  VALIDATE_MOBILE_FAIL: 'app/auth/VALIDATE_MOBILE_FAIL',
  RESEND_CLEAR: 'app/auth/RESEND_CLEAR',
  RESEND: 'app/auth/RESEND',
  RESEND_SUCCESS: 'app/auth/RESEND_SUCCESS',
  RESEND_FAIL: 'app/auth/RESEND_FAIL',
  AUTH_INIT: 'app/auth/AUTHENTICATE',
  AUTH_CALLBACK: 'app/auth/AUTHENTICATE_CALLBACK',
  LOAD_OWNERS: 'app/auth/LOAD_OWNERS',
  LOAD_OWNERS_SUCCESS: 'app/auth/LOAD_OWNERS_SUCCESS',
  LOAD_OWNERS_FAIL: 'app/auth/LOAD_OWNERS_FAIL',
  SEND_REQUEST: 'app/auth/SEND_REQUEST',
  SEND_REQUEST_SUCCESS: 'app/auth/SEND_REQUEST_SUCCESS',
  SEND_REQUEST_FAIL: 'app/auth/SEND_REQUEST_FAIL',
  SELECT_2FA_DELIVERY_METHOD: 'app/auth/SELECT_2FA_DELIVERY_METHOD',
  SET_USER: 'app/auth/SET_USER',
  CLEAN_UP: 'app/shift/CLEAN_UP',
  // Passkey login: PASSKEY_LOGIN_SUCCESS funnels into the same middleware
  // handling as LOGIN_SUCCESS (a verified passkey assertion starts a session
  // directly, having already satisfied user verification)
  PASSKEY_LOGIN: 'app/auth/PASSKEY_LOGIN',
  PASSKEY_LOGIN_SUCCESS: 'app/auth/PASSKEY_LOGIN_SUCCESS',
  PASSKEY_LOGIN_FAIL: 'app/auth/PASSKEY_LOGIN_FAIL',
  PASSKEY_LOGIN_OPTIONS_SUCCESS: 'app/auth/PASSKEY_LOGIN_OPTIONS_SUCCESS',
  // Passkey self-service management (session required)
  PASSKEY_REGISTER_OPTIONS: 'app/auth/PASSKEY_REGISTER_OPTIONS',
  PASSKEY_REGISTER_OPTIONS_SUCCESS: 'app/auth/PASSKEY_REGISTER_OPTIONS_SUCCESS',
  PASSKEY_REGISTER_OPTIONS_FAIL: 'app/auth/PASSKEY_REGISTER_OPTIONS_FAIL',
  PASSKEY_REGISTER_VERIFY: 'app/auth/PASSKEY_REGISTER_VERIFY',
  PASSKEY_REGISTER_VERIFY_SUCCESS: 'app/auth/PASSKEY_REGISTER_VERIFY_SUCCESS',
  PASSKEY_REGISTER_VERIFY_FAIL: 'app/auth/PASSKEY_REGISTER_VERIFY_FAIL',
  PASSKEY_LIST: 'app/auth/PASSKEY_LIST',
  PASSKEY_LIST_SUCCESS: 'app/auth/PASSKEY_LIST_SUCCESS',
  PASSKEY_LIST_FAIL: 'app/auth/PASSKEY_LIST_FAIL',
  PASSKEY_LIST_FOR_OWNER: 'app/auth/PASSKEY_LIST_FOR_OWNER',
  PASSKEY_LIST_FOR_OWNER_SUCCESS: 'app/auth/PASSKEY_LIST_FOR_OWNER_SUCCESS',
  PASSKEY_LIST_FOR_OWNER_FAIL: 'app/auth/PASSKEY_LIST_FOR_OWNER_FAIL',
  PASSKEY_RENAME: 'app/auth/PASSKEY_RENAME',
  PASSKEY_RENAME_SUCCESS: 'app/auth/PASSKEY_RENAME_SUCCESS',
  PASSKEY_RENAME_FAIL: 'app/auth/PASSKEY_RENAME_FAIL',
  PASSKEY_REVOKE: 'app/auth/PASSKEY_REVOKE',
  PASSKEY_REVOKE_SUCCESS: 'app/auth/PASSKEY_REVOKE_SUCCESS',
  PASSKEY_REVOKE_FAIL: 'app/auth/PASSKEY_REVOKE_FAIL',
  // Local, synchronous flip after a successful registration (see FTR-3
  // mandatory-registration hard-block) - not a server round-trip
  PASSKEY_REGISTERED: 'app/auth/PASSKEY_REGISTERED',
  // OWN-224 step-up: local, synchronous flip after any step-up verification
  // method succeeds - not a server round-trip (see VerificationRequired.js).
  SESSION_VERIFIED: 'app/auth/SESSION_VERIFIED',
  // Recovery-code generation (session required)
  RECOVERY_STATUS: 'app/auth/RECOVERY_STATUS',
  RECOVERY_STATUS_SUCCESS: 'app/auth/RECOVERY_STATUS_SUCCESS',
  RECOVERY_STATUS_FAIL: 'app/auth/RECOVERY_STATUS_FAIL',
  RECOVERY_STATUS_FOR_OWNER: 'app/auth/RECOVERY_STATUS_FOR_OWNER',
  RECOVERY_STATUS_FOR_OWNER_SUCCESS: 'app/auth/RECOVERY_STATUS_FOR_OWNER_SUCCESS',
  RECOVERY_STATUS_FOR_OWNER_FAIL: 'app/auth/RECOVERY_STATUS_FOR_OWNER_FAIL',
  RECOVERY_GENERATE: 'app/auth/RECOVERY_GENERATE',
  RECOVERY_GENERATE_SUCCESS: 'app/auth/RECOVERY_GENERATE_SUCCESS',
  RECOVERY_GENERATE_FAIL: 'app/auth/RECOVERY_GENERATE_FAIL',
};

export default types;
